import { render, staticRenderFns } from "./SearchSelectWidget.vue?vue&type=template&id=e60c057a&scoped=true"
import script from "./SearchSelectWidget.vue?vue&type=script&lang=js"
export * from "./SearchSelectWidget.vue?vue&type=script&lang=js"
import style0 from "./SearchSelectWidget.vue?vue&type=style&index=0&id=e60c057a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c057a",
  null
  
)

export default component.exports